<template>

  <v-autocomplete
    ref="autocomplete"
    v-model="c_hotel"
    autocomplete="off"
    auto-select-first
    type="search"
    placeholder="Hotel"
    :search-input="search"
    :items="hotels"
    item-value="id"
    item-text="name"
    color="primary"
    solo-inverted
    return-object
    hide-details
    flat
    @focus="magic_flag = false"
    @blur="magic_flag = true"
    style="max-width: 400px"
  >

    <template v-slot:selection="data">
      <div v-if="magic_flag && data.item">
        <v-list-item-title>{{data.item.name}}</v-list-item-title>
        <v-list-item-subtitle><small>ID: {{data.item.id}} - {{data.item.city}}, {{data.item.country}}</small></v-list-item-subtitle>
      </div>
    </template>

    <template v-slot:item="data">
      <div v-if="data.item">
        <v-list-item-title>{{data.item.name}}</v-list-item-title>
        <v-list-item-subtitle><small>ID: {{data.item.id}} - {{data.item.city}}, {{data.item.country}}</small></v-list-item-subtitle>
      </div>
    </template>

  </v-autocomplete>

</template>


<script>

  import hotel_repository from '@/repositories/hotel-repository'

  export default {

    data: () => ({
      search: null,
      hotel: null,
      hotels: null,
      magic_flag: true,
    }),

    async created() {
      this.hotels = await this.getHotels();
      this.hotel = await this.getHotel();

      await this.$store.dispatch('hotel/setHotel', this.hotel);
      await this.$root.$on('selectHotel', (val) => {
        this.c_hotel = val;
      });
    },

    computed: {
      c_hotel: {

        get() {
          if (!this.hotel) {
            this.hotel = this.$store.state.hotel;
          }

          return this.hotel;
        },

        set(val) {

          if (!val) {
            this.hotel = this.$store.state.hotel;
          } else {
            this.hotel = val;
          }

          this.$store.dispatch('hotel/setHotel', val);
          this.$refs.autocomplete.blur();

          if (this.$route.meta.redirect)
            this.$router.push(this.$route.meta.redirect.replace(':hotel', val.id));

        }
      }
    },

    methods: {

      async getHotels() {
        const hotels = await hotel_repository.getHotels(null, {size: 5000, page: 1});
        return hotels.data.map(hotel => (
            {
              id: hotel.id,
              name: hotel.name,
              city: hotel.static.location.address.city,
              country: hotel.static.location.address.country,
            }
          )
        );
      },

      async getHotel() {

        if (this.$route.params.hotel) {
          const hotel = await hotel_repository.getHotel(this.$route.params.hotel);
          return {
            id: hotel.id,
            name: hotel.name,
            city: hotel.static.location.address.city,
            country: hotel.static.location.address.country,
          };
        }

        if (this.$store.state.hotel && this.$store.state.hotel.id) {
          this.hotels.push(this.$store.state.hotel);
          return this.$store.state.hotel;
        }

        if (this.hotels && this.hotels.length) {
          return {
            id: this.hotels[0].id,
            name: this.hotels[0].name,
            city: this.hotels[0].city,
            country: this.hotels[0].country,
          };
        }

        return null;
      }
    }


  }
</script>